import type { ComponentProps, ReactNode, RefObject } from "react"
import { Button } from "@holigral/shared/ui/components/ui/button"

type Props = Omit<ComponentProps<typeof Button>, "size" | "variant"> & {
  icon: ReactNode
  size?: "icon" | "icon-xs" | "icon-sm" | "icon-lg"
  /** Icon buttons are the ghost unless a caller says otherwise. */
  variant?: ComponentProps<typeof Button>["variant"]
  ref?: RefObject<HTMLAnchorElement | null>
}

export default function IconButton({
  icon,
  size = "icon",
  variant = "ghost",
  ...buttonProps
}: Props) {
  return (
    <Button size={size} variant={variant} {...buttonProps}>
      {icon}
    </Button>
  )
}
